import { themeQuartz } from "ag-grid-community";


export const gridTheme = themeQuartz.withParams({
    fontFamily: "'Poppins Medium', 'Poppins', sans-serif",
    fontSize: 12,
    headerBackgroundColor: "#d7d7d7",
    borderColor: "#f0f0f0",
    headerHeight: 40,
    headerColumnBorder: { style: "solid", width: 0.5 },
    columnBorder: { style: "solid", width: 0.5 },
});